import type {z} from "zod";

import {
  createValidationIssue,
  invalidEmailValidation,
  requiredFieldValidation,
} from "@project/i18n";
import {CreateUserBody} from "@project/sdk/admin/zod";
import {z as zod} from "zod";

import {userFieldLabelIds} from "../../messages/users.messages";

const baseCreateUserNameSchema = CreateUserBody.shape.name;
const baseCreateUserEmailSchema = CreateUserBody.shape.email;

export const createUserNameSchema = zod.string().superRefine((value, ctx) => {
  if (!value.trim()) {
    ctx.addIssue(createValidationIssue(requiredFieldValidation(userFieldLabelIds.name)));

    return;
  }

  const result = baseCreateUserNameSchema.safeParse(value);

  if (!result.success) {
    for (const issue of result.error.issues) {
      ctx.addIssue({...issue});
    }
  }
});

export const createUserEmailSchema = zod.string().superRefine((value, ctx) => {
  if (!value.trim()) {
    ctx.addIssue(createValidationIssue(requiredFieldValidation(userFieldLabelIds.email)));

    return;
  }

  if (!baseCreateUserEmailSchema.safeParse(value).success) {
    ctx.addIssue(createValidationIssue(invalidEmailValidation(userFieldLabelIds.email)));
  }
});

export const createUserRichSchema = CreateUserBody.extend({
  name: createUserNameSchema,
  email: createUserEmailSchema,
});
export type CreateUserFormPayload = z.infer<typeof createUserRichSchema>;

export const draftUserRichSchema = createUserRichSchema.partial();
export type DraftUserFormPayload = z.infer<typeof draftUserRichSchema>;
